//QuizCornerHome.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShower, faCartShopping, faGlassMartini, faFistRaised, faRedo, faComment, faEdit, faPlusSquare, faBookAtlas, faSchoolCircleCheck } from '@fortawesome/free-solid-svg-icons';
import Tooltip from '../../components/utils/Tooltip';
import './styles/QuizCorner.css';
import './styles/BookShelf.css';
import quizcornerimage from '../../assets/pageimages/QuizCorner.webp';

import adImage from '../../assets/pageimages/bookworldlistad.webp';


const QuizCornerHome = () => {
    const tooltiptext = "About Think5Whys";

    return (
        <MainLayout>
            <div>
                <h3 className='text-lg mt-12 mx-8 border-b border-b-gray-300 text-white'>Learnings - QuizCorner</h3>
            </div>
            <div className="bookshelf-container w-7/12">
                <div className='relative inset-0 flex justify-center mt-2 mb-2'>
                    <img src={adImage} />
                </div>
                <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
                    <div className="button-links flex align-middle justify-center bg-gray-500">
                        <div className="bottom-buttons-box"><Link to="/quizcorner-library" className="top-button-link"><FontAwesomeIcon icon={faSchoolCircleCheck} className="quizcorner-bottomlink-style" />Live Quizzes</Link></div>
                        <div className="bottom-buttons-box"><Link to="/quizcorner-artbook" className="top-button-link"><FontAwesomeIcon icon={faBookAtlas} className="quizcorner-bottomlink-style" />My Quizzes</Link></div>
                        <div className="bottom-buttons-box"><Link to="/quizcorner-artbook" className="top-button-link"><FontAwesomeIcon icon={faBookAtlas} className="quizcorner-bottomlink-style" />Leaderboard</Link></div>
                    </div>
                </div>
                <div className="relative inset-0 flex border border-b-gray-300">
                    <img id="quizcorner-id" src={quizcornerimage} alt="QuizCorner Image" />
                </div>
            </div>
        </MainLayout>
    );
};

export default QuizCornerHome;
